'use strict';

var LAST_FILTER_PROPS = ['type', 'cityId'];
var trackingUtils = require('../../modules/utils/tracking.utils.js');
var filterMixin = require('./utils/filter.mixin.js');
var checkBoxFilterMixin = require('./utils/checkbox_filter.mixin');
var checkBoxFilterViewMixin = require('./utils/checkbox_filter.view.mixin');
var filterViewMixin = require('./utils/filter.view.mixin');
var filterModelMixin = require('./utils/filter.model.mixin');
var templateSelectorsViewMixin = require('./utils/template_selector.view.mixin');
var isNewCollection = function(collection, models) {
    models = Odigeo._.isArray(models) ? models : models.models;
    return collection.length !== models.length || Odigeo._.some(models, function(model) {
        return !collection.get(model.id);
    });
};
var BBModel = Backbone.Model;
var BBModelProtoSet = BBModel.prototype.set;
var BBCollection = Backbone.Collection;
var CheckboxCollection = require('./utils/checkbox.collection');
var AirportModel = Backbone.Model.extend();
var AirportCollection = CheckboxCollection.extend({
    model: AirportModel,
});
var SameAirportModel = BBModel.extend({
    defaults: {
        checked: false,
    },
});
var parseSetMethodArgs = require('../../modules/utils/model.utils').parseSetMethodArgs;
var CityModel = BBModel.extend({
    defaults: function() {
        return {
            sameAirport: new SameAirportModel(),
            airportCollection: new AirportCollection(),
        };
    },
    set: function() {
        var args = parseSetMethodArgs(arguments);
        var attrs = args[0];
        var options = args[1];
        var simpleData = Odigeo._.omit(attrs, 'sameAirport', 'airportCollection');
        if (Odigeo._.isEmpty(this.attributes)) {
            BBModelProtoSet.call(this, this.defaults());
        }
        options.parentModel.get('lastFilter').cityId = attrs.id;
        this.get('sameAirport').set(attrs.sameAirport);
        this.get('airportCollection').reset(attrs.airportCollection);
        BBModelProtoSet.call(this, simpleData, options);
    },
});
var CityCollection = BBCollection.extend({
    model: CityModel,
    reset: function(models, options) {
        if (isNewCollection(this, models)) {
            BBCollection.prototype.reset.call(this, models, options);
        } else {
            this.set(models, options);
        }
    },
});
var CITY_TYPES = ['origin', 'destination'];
var isAirportCollectionApplied = function(airportCollection) {
    return airportCollection.length !== airportCollection.numSelected;
};
var airportCollectionToRequest = function(airportCollection) {
    return Array.isArray(airportCollection.models)
        && airportCollection.models.filter((airport) => airport.get('active'))
            .map((airport) => airport.get('id'));
};

Odigeo.defineWidget('airports_filter', Odigeo.Widget.extend(Odigeo._.defaults({
    viewClass: Odigeo.View.extend(Odigeo._.defaults({
        renderAirportCollection: function(airportCollection, airportSelectors) {
            airportCollection.each(Odigeo._.bind(function(airport) {
                airportSelectors[airport.get('id')].prop('checked', airport.get('active'));
            }, this));
        },

        getAirportSelectors: function(params) {
            var type = params.type;
            return type === 'stopover' ? this.$cachedSelectors.stopoverAirports : this.$cachedSelectors.cities[type][params.cityId];
        },

        renderSameAirports: function(cityType, city) {
            const $oneAirport = this.$cachedSelectors.cities[cityType][city.get('id')];
            if ($oneAirport && $oneAirport.sameAirport ) {
                $oneAirport.sameAirport.container.toggleClass('odf-hidden', !city.get('sameAirport').get('visible'));
                $oneAirport.sameAirport.input.prop('checked', city.get('sameAirport').get('checked'));
            }
        },

        renderAirports: function() {
            var $cachedSelectors = this.$cachedSelectors;
            Odigeo._.each(CITY_TYPES, Odigeo._.bind(function(cityType) {
                this.model.get(cityType).each(Odigeo._.bind(function(city) {
                    var airportCollection = city.get('airportCollection');
                    var airportSelectors = this.getAirportSelectors({
                        type: cityType,
                        cityId: city.get('id'),
                    });
                    if (airportSelectors) {
                        this.renderAirportCollection(airportCollection, airportSelectors);
                    }
                    this.renderSelectionShortcuts(city.toJSON(), airportCollection, airportCollection.numSelected);
                    this.renderSameAirports(cityType, city);
                }, this));
            }, this));
            if ($cachedSelectors.stopovers.length) {
                var stopoverAirportCollection = this.model.get('stopoverAirports');
                this.renderAirportCollection(stopoverAirportCollection, $cachedSelectors.stopoverAirports);
                this.renderSelectionShortcuts({
                    type: 'stopover',
                }, stopoverAirportCollection, stopoverAirportCollection.numSelected);
            }
        },

        getCachedAirports: function($city) {
            var $airports = $city.find('.filter_check');
            return Odigeo._.reduce($airports, function(result, airport) {
                var $airport = $(airport);
                var airportId = $airport.data('id');
                result[airportId] = $airport;
                return result;
            }, {});
        },

        getCachedCitiesByType: function(cityType) {
            var $cities = this.$el.find('.' + cityType + '_airports_filters .airports_city_filter');
            return Odigeo._.reduce($cities, Odigeo._.bind(function(result, city) {
                var $city = $(city);
                var cityId = $city.data('id');
                result[cityId] = this.getCachedAirports($city);
                result[cityId].buttonAll = $city.find('.button_all');
                result[cityId].buttonNone = $city.find('.button_none');
                result[cityId].sameAirport = {
                    container: $city.find('.same_airports_container'),
                    input: $city.find('.same_airports_input'),
                };
                return result;
            }, this), {});
        },

        updateDomSelectorsToCache: function() {
            var $cachedSelectors = this.$cachedSelectors = {};
            var $stopoversContainer = this.$el.find(this.templateSelectors.stopovers);
            var stopoverAirports = this.getCachedAirports($stopoversContainer);
            $cachedSelectors.cities = Odigeo._.reduce(CITY_TYPES, Odigeo._.bind(function(result, cityType) {
                result[cityType] = this.getCachedCitiesByType(cityType);
                return result;
            }, this), {});
            stopoverAirports.buttonAll = $stopoversContainer.find('.button_all');
            stopoverAirports.buttonNone = $stopoversContainer.find('.button_none');
            $cachedSelectors.stopovers = $stopoversContainer;
            $cachedSelectors.stopoverAirports = stopoverAirports;
        },

        setIsFiltered: function() {
            var model = this.model;
            Odigeo.trigger(this.widget.widgetType + ':filtersUpdated', model.get('idx'), 'airports_filter', model.isFilterAppliedAll());
        },

        initFilter: function() {
            var idx = this.model.get('idx');
            this.renderAirports();
            this.changeQueryState([
                {query: 'input[name=citiesOrigin_' + idx + ']', actions: {checked: true}},
                {query: 'input[name=citiesDestination_' + idx + ']', actions: {checked: true}},
            ]);
            this.setIsFiltered();
        },

        onCitiesFilter: function(params) {
            // FIX selectors because the splitting of the filters manager to airports filter widget
            var $el = $('#citiesDestination_' + params.locationId + '_' + params.tabId);
            var $cities = $('[id^=citiesDestination]');
            var clickedCityIndex = $cities.index($el) + 1;
            var isChecked = $el.is(':checked');

            this[isChecked ? 'resetFilter' : 'onButtonNoneClick'](params);

            // Analytics: event tracking
            trackingUtils.trackEvent(
                'results_filters',
                '1_segment_destination_' + clickedCityIndex + '_' + (isChecked ? 'checked' : 'unchecked'),
                'flights_results'
            );
        },

        events: {
            'tap .filter_only': 'onOnlyClickFilter',
            'change .filter_check': 'onFilter',
            'tap .button_all': 'onButtonAllClick',
            'tap .button_none': 'onButtonNoneClick',
            'change .same_airports_input': 'onSameAirportFilter',
        },

        onFilter: function(event) {
            var params = this.getParams(event);
            var airportId = params.id;
            var airportCollection = this.model.getAirportCollection(params);
            this.model.set('lastFilter', Odigeo._.pick(params, LAST_FILTER_PROPS));
            airportCollection.toggle(airportId);
        },

        onOnlyClickFilter: function(event) {
            event.preventDefault();
            var params = this.getParams(event);
            var airportCollection = this.model.getAirportCollection(params);
            var airportSelectors = this.getAirportSelectors(params);
            var airportId = params.id;
            this.model.set('lastFilter', Odigeo._.pick(params, LAST_FILTER_PROPS));
            airportCollection.turnOnById(airportId);
            this.renderAirportCollection(airportCollection, airportSelectors);
        },

        resetFilter: function(params) {
            this.model.set('lastFilter', Odigeo._.pick(params, LAST_FILTER_PROPS));
            var airportSelectors = this.getAirportSelectors(params);
            this.model.getAirportCollection(params).turnOnAll();
            this.renderAirportCollection(this.model.getAirportCollection(params), airportSelectors);
            if (params.type !== 'stopover') {
                this.model.getCity(params).get('sameAirport').set('checked', false);
            }
        },

        onSameAirportFilter: function(event) {
            var params = this.getParams(event);
            var city = this.model.getCity(params);
            var sameAirportModel = city.get('sameAirport');
            var requestType = {
                origin: 'returnSameOrigin',
                destination: 'departSameDestination',
            }[params.type];
            var prop = 'checked';
            this.model.set('lastFilter', Odigeo._.pick(params, LAST_FILTER_PROPS));
            sameAirportModel.set(prop, !sameAirportModel.get(prop));
            this.model.filterRequest([requestType]);
            trackingUtils.trackEvent('results_filters', 'airports_' + params.type + '_same_checked');
        },

        onReturnSameOriginFilter: function() {
            this.model.filterRequest(['returnSameOrigin']);
            trackingUtils.trackEvent('results_filters', 'airports_origin_same_checked');
        },

        onDepartSameDestinationFilter: function() {
            this.model.filterRequest(['departSameDestination']);
            trackingUtils.trackEvent('results_filters', 'airports_destination_same_checked');
        },

        renderSelectionShortcuts: function(city, airportCollection, numSelected) {
            var citySelectors = this.getAirportSelectors({
                type: city.type,
                cityId: city.id,
            });
            var allDisabled = numSelected === airportCollection.length;
            var noneDisabled = numSelected === 0;
            if (citySelectors) {
                citySelectors.buttonAll.prop('disabled', allDisabled);
                citySelectors.buttonNone.prop('disabled', noneDisabled);
            }
        },

        onButtonAllClick: function(event) {
            var params = this.getParams(event);
            trackingUtils.trackEvent('results_filters', 'airports_' + params.type + '_select_all', 'flights_results');
            this.resetFilter(params);
        },

        onButtonNoneClick: function(event) {
            var params = this.getParams(event);
            var airportCollection = this.model.getAirportCollection(params);
            var airportSelectors = this.getAirportSelectors(params);
            this.model.set('lastFilter', Odigeo._.pick(params, LAST_FILTER_PROPS));
            airportCollection.turnOffAll();
            this.renderAirportCollection(airportCollection, airportSelectors);
            trackingUtils.trackEvent('results_filters', 'airports_' + params.type + '_select_none', 'flights_results');
            if (this.widget.options.updateOnNoneSelected) {
                Odigeo.trigger('filters-manager:zeroFilteredResults');
            }
        },

        onToggle: function(model) {
            var filterType = this.model.get('lastFilter').type;
            var legLabel = this.model.tripType === 'multipleTrip' ? 'middle' : filterType;
            var requestType = filterType + 's';
            var checkedString = model.get('active') ? 'checked' : 'unchecked';
            this.model.filterRequest([requestType]);
            trackingUtils.trackEvent(
                'results_filters',
                'airports_' + legLabel + '_' + checkedString + '_' + model.get('iata').toLowerCase(),
                'flights_results'
            );
            this.setIsFiltered();
        },

        onSelectedOne: function(models) {
            var model = models[0];
            var filterType = this.model.get('lastFilter').type;
            var legLabel = this.model.tripType === 'multipleTrip' ? 'middle' : filterType;
            var requestType = filterType + 's';
            this.model.filterRequest([requestType]);
            trackingUtils.trackEvent('results_filters', 'airports_' + legLabel + '_checked_only_' +
                model.get('iata').toLowerCase(), 'flights_results');
        },

        onToggleAll: function() {
            this.setIsFiltered();
            var filterType = this.model.get('lastFilter').type;
            this.model.filterRequest([filterType + 's']);
        },

        manageStopoverAirports: function(maxStopoversSelected) {
            this.changeQueryState([
                {query: 'input[name=stopover' + this.model.get('idx') + ']', actions: {disabled: maxStopoversSelected === 0}},
            ]);
        },

        templateSelectors: {
            stopovers: '.filter_airports_stopover',
        },
    }, checkBoxFilterViewMixin, templateSelectorsViewMixin, filterViewMixin)),

    modelClass: Odigeo.Model.extend(Odigeo._.defaults({
        tripType: '',
        init: function() {
            this.tripType = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')).type;
        },
        getRequestModel: function(filterType) {
            return filterType === 'stopover' ?
                this.getStopoverRequestModel() :
                this.getCityAirportsModel(filterType);
        },
        getCityAirportsModel: function(filterType) {
            const cities = this.get(filterType);
            const selectedItems = cities.reduce(function(result, city) {
                result[city.id] = airportCollectionToRequest(city.get('airportCollection'));
                return result;
            }, {});
            return {
                selectedItems,
            };
        },
        getStopoverRequestModel: function() {
            return {
                selectedItems: airportCollectionToRequest(this.get('stopoverAirports')),
            };
        },
        isZeroApplied: function(filterType) {
            var cities = this.get(filterType);
            return cities.some(function(city) {
                return city.get('airportCollection').numSelected === 0;
            }, {});
        },
        getSameAirportRequestModel: function() {
            var city = this.getCity(this.get('lastFilter'));
            return {
                checked: city.get('sameAirport').get('checked'),
            };
        },
        getCity: function(params) {
            return this.get(params.type).get(params.cityId);
        },
        getAirportCollection: function(params) {
            return params.type === 'stopover' ? this.get('stopoverAirports') : this.getCity(params).get('airportCollection');
        },
        isFilterAppliedAll: function() {
            const stopoverAirportCollection = this.get('stopoverAirports');
            return isAirportCollectionApplied(stopoverAirportCollection) ||
                Odigeo._.some(CITY_TYPES, (cityType) => {
                    return Odigeo._.some(this.get(cityType).models, (cityTypeModel) => {
                        return isAirportCollectionApplied(cityTypeModel.get('airportCollection'));
                    });
                });
        },
        isFilterApplied: function() {
            var params = this.get('lastFilter');
            return !Odigeo._.isEmpty(params) && (this.getCity(params).get('sameAirport').get('checked') ||
                isAirportCollectionApplied(this.getAirportCollection(params)));
        },
        initModel: function(data) {
            const options = {
                parentModel: this,
            };
            if (this.widget.options.showOnlyAirports) {
                Odigeo._.each(CITY_TYPES, Odigeo._.bind(function(cityType) {
                    this.get('lastFilter').type = cityType;
                    this.get(cityType).reset(Odigeo._.map(data[cityType], function(city) {
                        return Odigeo._.merge({
                            sameAirport: {
                                checked: false,
                            },
                            type: cityType,
                        }, city);
                    }), options);
                }, this));
            }
            if (this.widget.options.showOnlyStopoverAirports) {
                this.get('stopoverAirports').reset(data.stopoverAirports);
            }
        },
        getTagInfo: function() {
            var lastFilter = this.get('lastFilter');
            var airportCollection = this.getAirportCollection(lastFilter);
            var airport = airportCollection.find(Odigeo._.method('get', 'active'));
            return lastFilter ? Odigeo._.extend({
                cityName: this.getCity(lastFilter).get('name'),
                airportName: Odigeo._.method('get', 'name')(airport),
                numSelected: airportCollection.numSelected,
            }, lastFilter) : {};
        },
        defaults: function() {
            return {
                lastFilter: {},
                origin: new CityCollection(),
                destination: new CityCollection(),
                stopoverAirports: new AirportCollection(),
            };
        },
    }, filterModelMixin)),

    bindAirportEvents: function(airportCollection, location) {
        var widget = this;
        var view = widget.view;
        widget.listenTo(airportCollection, 'toggle', Odigeo._.bind(view.onToggle, view));
        widget.listenTo(airportCollection, 'turn-on-all', Odigeo._.bind(view.onToggleAll, view, 'all'));
        widget.listenTo(airportCollection, 'turn-off-all', Odigeo._.bind(view.onToggleAll, view, 'none'));
        widget.listenTo(airportCollection, 'change:numSelected', Odigeo._.bind(view.renderSelectionShortcuts, view, location));
    },

    bindEvents: function() {
        const widget = this;
        const {view, model} = widget;

        if (widget.options.showOnlyAirports) {
            Odigeo._.each(CITY_TYPES, function(cityType) {
                model.get(cityType).each(function(city) {
                    const airportCollection = city.get('airportCollection');
                    const sameAirportModel = city.get('sameAirport');
                    widget.listenTo(airportCollection, 'turn-on', Odigeo._.bind(view.onSelectedOne, view));
                    widget.bindAirportEvents(airportCollection, city.toJSON());
                    widget.listenTo(sameAirportModel, 'change', Odigeo._.bind(view.renderSameAirports, view, cityType, city));
                    widget.listenTo(airportCollection, 'update', widget.triggerFilterChange);
                    widget.listenTo(airportCollection, 'reset', widget.triggerFilterChange);
                    widget.listenTo(sameAirportModel, 'change', widget.triggerFilterChange);
                });
            });
        }

        if (widget.options.showOnlyStopoverAirports) {
            const stopoverAirportCollection = model.get('stopoverAirports');
            this.bindAirportEvents(stopoverAirportCollection, {
                type: 'stopover',
            });
        }
    },

    checkNullFilter: function(params, cb) {
        this.rebuildWidgetIfNeeded(params.tabId);
        this.view.checkNullFilter(params, cb);
    },

    onMobileStopoversFilter: function(params) {
        this.rebuildWidgetIfNeeded(params.tabId);
        this.view.onMobileStopoversFilter(params.id);
    },

    onDepartSameDestinationFilter: function(idx) {
        this.rebuildWidgetIfNeeded(idx);
        this.view.onDepartSameDestinationFilter(idx);
    },

    onReturnSameOriginFilter: function(idx) {
        this.rebuildWidgetIfNeeded(idx);
        this.view.onReturnSameOriginFilter(idx);
    },

    sendRequestModel: function(requestType, idx) {
        var cityType = requestType.replace(/s$/, '');
        this.rebuildWidgetIfNeeded(idx);
        var getRequestModel = this.requestTypeToModelBuilding[requestType];
        var requestModel = this.model[getRequestModel](cityType);
        Odigeo.trigger(this.widgetType + ':sendFilterModel', requestModel, requestType, idx);
    },

    sendIsZeroApplied: function(requestType, idx) {
        var cityType = requestType.replace(/s$/, '');
        Odigeo.trigger(this.widgetType + ':sendIsZeroApplied', this.model.isZeroApplied(cityType), requestType, idx);
    },

    getTagId: function() {
        var model = this.model;
        return this.name + '-' + model.get('idx') + '-' + Odigeo._.values(model.get('lastFilter')).join('-');
    },

    requestTypeToModelBuilding: {
        origins: 'getRequestModel',
        destinations: 'getRequestModel',
        stopovers: 'getRequestModel',
        returnSameOrigin: 'getSameAirportRequestModel',
        departSameDestination: 'getSameAirportRequestModel',
    },
    filterType: 'airports',

    init: function() {
        this.buildOptions();
    },
    manageStopoverAirports: function(maxStopoversSelected) {
        this.view.manageStopoverAirports(maxStopoversSelected);
    },
}, filterMixin, checkBoxFilterMixin)));
